var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHighPriorityTaskIcon = function SvgHighPriorityTaskIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.998,
    height: 17.999,
    viewBox: "0 0 17.998 17.999"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "High priority general"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fc4dff",
    d: "M17.998 17.999h-18v-18h18v18Zm-9-15a.791.791 0 0 0-.657.323l-7.2 10.419a.794.794 0 0 0-.139.406.808.808 0 0 0 .089.424.78.78 0 0 0 .3.313.8.8 0 0 0 .413.114h14.4a.787.787 0 0 0 .414-.117.79.79 0 0 0 .292-.313.819.819 0 0 0 .092-.42.787.787 0 0 0-.142-.406L9.66 3.323A.791.791 0 0 0 8.999 3Z",
    "data-name": "Path 11552"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.798 15h14.4a.8.8 0 0 0 .708-.43.8.8 0 0 0-.049-.827l-7.2-10.419a.83.83 0 0 0-1.315 0l-7.2 10.419a.8.8 0 0 0-.051.828.8.8 0 0 0 .707.429Z",
    "data-name": "Path 2345"
  }))));
};
export default SvgHighPriorityTaskIcon;